// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/toast.js
import BaseComponent from "./base_component"

export default class Toast extends BaseComponent {
  static componentName = "toast"
  static defaults = { autohide: true, delay: 5000, animation: true }

  constructor(element, config = {}) {
    super(element, config)
    this.interactions = new Set()
    for (const [start, end, name] of [
      ["mouseenter", "mouseleave", "mouse"],
      ["focusin", "focusout", "focus"],
    ]) {
      this.listen(element, start, () => {
        this.interactions.add(name)
        clearTimeout(this.timeout)
      })
      this.listen(element, end, (event) => {
        if (element.contains(event.relatedTarget)) return
        this.interactions.delete(name)
        this.scheduleHide()
      })
    }
  }

  show() {
    if (this.transitioning || this.emit("show", {}, { cancelable: true }).defaultPrevented) return
    clearTimeout(this.timeout)
    this.transitioning = true
    this.element.classList.toggle("fade", this.config.animation)
    this.element.classList.remove("hide")
    this.element.offsetHeight
    this.element.classList.add("show", "showing")
    this.afterTransition(
      this.element,
      () => {
        this.element.classList.remove("showing")
        this.transitioning = false
        this.emit("shown")
        this.scheduleHide()
      },
      this.config.animation,
    )
  }

  scheduleHide() {
    clearTimeout(this.timeout)
    if (this.config.autohide && !this.interactions.size && this.element.classList.contains("show"))
      this.timeout = setTimeout(() => this.hide(), this.config.delay)
  }

  hide() {
    if (
      this.transitioning ||
      !this.element.classList.contains("show") ||
      this.emit("hide", {}, { cancelable: true }).defaultPrevented
    )
      return
    clearTimeout(this.timeout)
    this.transitioning = true
    this.element.classList.add("showing")
    this.afterTransition(
      this.element,
      () => {
        this.element.classList.remove("show", "showing")
        this.element.classList.add("hide")
        this.transitioning = false
        this.emit("hidden")
      },
      this.config.animation,
    )
  }

  dispose() {
    if (this.signal.aborted) return
    clearTimeout(this.timeout)
    this.element.classList.remove("show", "showing")
    this.element.classList.add("hide")
    super.dispose()
  }
}
